<template>
  <v-dialog
    v-model="isVisible"
    :width="component.dialog.width"
    :fullscreen="component.dialog.fullscreen"
    persistent
    scrollable
    content-class="rounded-dialog"
  >
    <v-card :class="classes" :style="styles + ';' + gradient">
      <v-btn
        v-if="
          component.dialog.title.floatText === 'text-right' &&
            component.dialog.fullscreen === true
        "
        top
        left
        absolute
        small
        icon
        @click="onClose"
        style="z-index: 100"
      >
        <v-icon :color="component.dialog.title.color">clear</v-icon>
      </v-btn>
      <v-btn
        v-if="
          component.dialog.title.floatText !== 'text-right' &&
            component.dialog.fullscreen === true
        "
        top
        right
        absolute
        small
        icon
        @click="onClose"
        style="z-index: 100"
      >
        <v-icon :color="component.dialog.title.color">clear</v-icon>
      </v-btn>
      <v-row no-gutters>
        <v-col cols="auto">
          <view-dialog-icon
            v-if="
              component.dialog.icon.placement === 'left' &&
                component.dialog.icon.show === true
            "
            :card="offerData"
            :component="component"
          ></view-dialog-icon>
        </v-col>
        <v-col>
          <v-row
            no-gutters
            :justify="component.dialog.icon.justify"
            v-if="
              component.dialog.icon.placement === 'top' &&
                component.dialog.icon.show === true
            "
          >
            <view-dialog-icon
              :card="offerData"
              :component="component"
            ></view-dialog-icon>
          </v-row>
          <view-text
            :settings="component.dialog.opportunityTitle"
            :value="opportunity.title"
          ></view-text>
          <view-text
            v-if="component.dialog.deadline.show && opportunity.deadline"
            :settings="component.dialog.deadline"
            :value="formatDeadline(opportunity.deadline)"
          ></view-text>
          <view-text
            v-if="component.dialog.points.show"
            :settings="component.dialog.points"
            :value="opportunity.points + ' Points'"
          ></view-text>
          <view-text
            :settings="component.dialog.deadline"
            :value="opportunity.description"
            :isHtml="true"
          ></view-text>
          <v-row
            no-gutters
            :justify="component.dialog.icon.justify"
            v-if="
              component.dialog.icon.placement === 'bottom' &&
                component.dialog.icon.show === true
            "
          >
            <view-dialog-icon
              :card="offerData"
              :component="component"
            ></view-dialog-icon>
          </v-row>
        </v-col>
        <v-col cols="auto">
          <view-dialog-icon
            v-if="
              component.dialog.icon.placement === 'right' &&
                component.dialog.icon.show === true
            "
            :card="offerData"
            :component="component"
          ></view-dialog-icon>
        </v-col>
      </v-row>
      <div class="ma-0 pa-0">
        <v-card color="transparent" elevation="0">
          <v-tabs
            class="mb-6 mt-3 custom-tabs"
            v-model="tab"
            background-color="transparent"
            centered
          >
            <v-tab class="custom-tab">New Claim</v-tab>
            <v-tab class="custom-tab">Claim History</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" background-color="transparent">
            <v-tab-item color="transparent">
              <v-row justify="center" no-gutters>
                <v-btn
                  :color="buttonColor"
                  :class="buttonTextColor"
                  elevation="0"
                  @click="openClaimForm"
                  :disabled="!isClaimFormOpen"
                >
                  enter new claim
                </v-btn>
              </v-row>
              <v-row
                justify="center"
                no-gutters
                v-if="!isClaimFormOpen"
                class="mt-2"
              >
                <v-col cols="12" class="text-center">
                  <v-icon :color="buttonColor">event</v-icon>
                  <span class="text-center" :style="{ color: buttonColor }">
                    The claim form is now closed
                  </span>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item color="transparent">
              <v-data-table
                :headers="headers"
                :items="userEntries"
                :style="cssVars"
                class="table"
                no-data-text="No claims yet"
                :page.sync="page"
                @page-count="pageCount = $event"
                :items-per-page="itemsPerPage"
                hide-default-footer
                :loading="loading"
                :item-class="rowClass"
                item-key="_id"
              >
                <template v-slot:[`item.status`]="{ item }">
                  <status-icon :status="item.status" class="pr-3"></status-icon>
                  {{ item.status }}
                </template>

                <template v-slot:[`item.comments`]="{ item }">
                  <span>{{ item.comments || "" }}</span>
                </template>

                <template v-slot:[`item.totalPoints`]="{ item }">
                  <span v-if="item.totalPoints > 0">{{
                    item.totalPoints | number
                  }}</span>
                  <span v-else>-</span>
                </template>

                <template v-slot:[`item.submitted`]="{ item }">
                  {{ formatDate(item.submitted) }}
                </template>

                <template v-slot:[`item.reviewed`]="{ item }">
                  <span v-if="item.reviewed">{{
                    formatDate(item.reviewed)
                  }}</span>
                  <span v-else>-</span>
                </template>
              </v-data-table>

              <v-row
                justify="center"
                v-if="pageCount > 1"
                no-gutters
                class="mt-2"
                align="center"
              >
                <v-btn
                  v-if="page > 1"
                  rounded
                  x-small
                  elevation="0"
                  color="transparent"
                  @click="page--"
                >
                  <v-icon
                    :color="this.component.dialog.content.heading.color"
                    size="20"
                    >chevron_left</v-icon
                  >
                </v-btn>
                <v-btn
                  v-for="page in pageCount"
                  :key="page"
                  x-small
                  elevation="0"
                  color="transparent"
                  rounded
                  @click="handlePage(page)"
                >
                  <span :style="cssVars" :class="paginationStyle(page)">
                    {{ page }}
                  </span>
                </v-btn>
                <v-btn
                  v-if="page < pageCount"
                  rounded
                  x-small
                  elevation="0"
                  color="transparent"
                  @click="page++"
                >
                  <v-icon
                    :color="this.component.dialog.content.heading.color"
                    size="20"
                    >chevron_right</v-icon
                  >
                </v-btn>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>

      <v-card-actions class="ma-0 pa-0">
        <v-spacer></v-spacer>
        <v-btn
          v-if="component.dialog.fullscreen !== true"
          @click="close()"
          text
          class="close-button"
          >{{ $t("close") }}</v-btn
        >
      </v-card-actions>
      <claim-form
        v-if="showClaimForm"
        :open="showClaimForm"
        @onClose="closeClaimForm"
        @onCancel="closeClaimForm"
        :previewArr="formPagesArray"
        :component="component"
        :opportunity="opportunity"
        :parentOfferId="
          offerData.isAdvancedGroup ? offerData.parentOfferId : null
        "
        :memberId="currentUser._id"
        :opportunityId="opportunity.id"
      />
    </v-card>
  </v-dialog>
</template>

<script>
// Remeber to add "cardType: 'offer'" to the offer data function as it is needed to activate the correct icon
import ViewText from "../Text.vue";
import ViewDialogIcon from "../DialogIcon.vue";
import claimForm from "./Form/Main.vue";
import DateUtils from "@/utils/DateUtils";

export default {
  components: {
    ViewText,
    ViewDialogIcon,
    claimForm
  },
  props: ["isVisible", "onClose", "offerData", "opportunity", "component"],
  created() {
    if (this.offerData && this.offerData.form && this.offerData.form.pages) {
      // Initialize formPagesArray with JSON parsed data to remove reactivity
      if (Array.isArray(this.offerData.form.pages)) {
        this.formPagesArray = JSON.parse(
          JSON.stringify(this.offerData.form.pages)
        );
      }
    }
  },
  watch: {
    isVisible: {
      immediate: false,
      handler(newVal) {
        if (newVal && this.offerData) {
          // Load just the offer when dialog opens
          const offerId = this.getEffectiveOfferId();

          if (offerId) {
            this.$store.dispatch("loadCurrentOffer", offerId).catch(error => {
              console.error("Error loading offer:", error);
            });
          }
        } else if (!newVal) {
          // Reset state when dialog is closed
          this.tab = 0; // Switch back to the first tab
          this.entriesLoaded = false;
          this.loading = false;
          this.$store.dispatch("cleanupEntriesListener");
        }
      }
    },
    tab(newVal) {
      // Load entries only when user clicks on the Claim History tab (tab index 1)
      if (newVal === 1 && !this.entriesLoaded) {
        this.loadEntries();
      }
    }
  },
  beforeDestroy() {
    // Clean up the entries listener when component is destroyed
    this.$store.dispatch("cleanupEntriesListener");
  },
  data: function() {
    return {
      tab: null,
      claimFormValid: true,
      productFormValid: true,
      date: null,
      menu2: false,
      showClaimForm: false,
      formPagesArray: [],
      tempClaim: {
        items: []
      },
      code: null,
      serial: null,
      quantity: 1,
      price: null,
      invoiceNumber: null,
      purchaseOrder: null,
      invoiceDate: null,
      loading: false,
      entriesLoaded: false, // Track if entries have been loaded
      fileToUpload: [],
      delDialog: false,
      selectedEntry: null,
      rules: [],
      dropzoneOptions: {
        url: "https://httpbin.org/post", // Dummy Post URL,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        addRemoveLinks: true,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" }
      },
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      show: false,
      // Table settings
      options: {
        sortBy: ["submitted"],
        sortDesc: [true],
        itemsPerPage: 5,
        sortable: true,
        multiSort: true,
        search: true,
        filter: false,
        upload: true,
        download: true,
        more: false
      }
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("Status"), value: "status", align: "left" },
        { text: this.$t("Comments"), value: "comments", align: "left" },
        { text: this.$t("Submitted"), value: "submitted", align: "left" },
        { text: this.$t("Reviewed"), value: "reviewed", align: "left" },
        { text: this.$t("Points"), value: "totalPoints", align: "right" }
      ];
    },
    // Old data handling
    programId() {
      return this.$store.getters.programId;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    entries() {
      return this.$store.getters.currentOfferEntries;
    },
    buttonColor() {
      if (
        this.component.dialog.button &&
        this.component.dialog.button.color &&
        this.component.dialog.button.color.hexa
      ) {
        return this.component.dialog.button.color.hexa;
      } else {
        return this.$store.state.program.currentProgram.webTheme.colors.primary
          .hexa;
      }
    },
    buttonTextColor() {
      if (this.component.dialog.button && this.component.dialog.button.dark) {
        return this.component.dialog.button.dark;
      } else {
        return "white--text";
      }
    },
    userEntries() {
      // Temporary debug logging for retesting - can be removed once issue is identified
      if (this.entries.length > 0) {
        console.log(
          "🔍 [RETEST] Raw entries structure:",
          this.entries.map(entry => ({
            id: entry.id,
            _id: entry._id,
            member: entry.member,
            opportunity: entry.opportunity,
            status: entry.status,
            hasValidStructure: entry && typeof entry === "object"
          }))
        );
      }

      // Filter entries to show only those for this user and for this specific opportunity
      // And create a map to avoid duplicates (using id as the unique key)
      const entriesMap = new Map();

      try {
        this.entries
          .filter(entry => {
            // Defensive check for entry validity
            if (!entry || typeof entry !== "object") {
              console.warn("Invalid entry found:", entry);
              return false;
            }

            // Check that the entry is for the current user
            const isCorrectMember = entry.member === this.currentUser._id;

            // For regular opportunities
            if (this.opportunity.id) {
              // Check if this is the correct opportunity
              const isCorrectOpportunity =
                entry.opportunity === this.opportunity.id;

              // Return true if both member and opportunity match
              return isCorrectMember && isCorrectOpportunity;
            }

            // For opportunities from advanced offer groups
            if (this.opportunity.parentOfferId && this.opportunity.id) {
              // Check if this is the correct opportunity
              const isCorrectOpportunity =
                entry.opportunity === this.opportunity.id;

              // Return true if both member and opportunity match
              return isCorrectMember && isCorrectOpportunity;
            }

            return false;
          })
          .forEach(entry => {
            try {
              // First try to get the entry's id (primary identifier from Firestore)
              let entryId = entry.id;

              // If id is not available, try _id as fallback
              if (!entryId && entry._id) {
                entryId = entry._id;
              }

              // If still no ID, try using property descriptor to access id
              if (
                !entryId &&
                Object.prototype.hasOwnProperty.call(entry, "id")
              ) {
                const descriptor = Object.getOwnPropertyDescriptor(entry, "id");
                if (descriptor && descriptor.value) {
                  entryId = descriptor.value;
                }
              }

              // As a last resort, generate a random ID
              if (!entryId) {
                console.warn("Entry missing id:", entry);
                entryId = Math.random()
                  .toString(36)
                  .substr(2, 9);
                // Add the generated ID to the entry - use 'id' as the primary identifier
                entry.id = entryId;
              }

              // Validate entryId is a string
              if (typeof entryId !== "string" || entryId.length === 0) {
                console.warn(
                  "Invalid entryId generated:",
                  entryId,
                  "for entry:",
                  entry
                );
                return; // Skip this entry
              }

              // Ensure consistent _id property for v-data-table
              if (!entry._id) {
                entry._id = entryId;
              }

              // Use the determined ID as the key in our map to avoid duplicates
              entriesMap.set(entryId, entry);
            } catch (entryError) {
              console.error(
                "Error processing individual entry:",
                entryError,
                entry
              );
            }
          });
      } catch (error) {
        console.error("Error in userEntries computed property:", error);
        // Return empty array on error to prevent component crash
        return [];
      }

      // Convert the Map back to an Array
      const result = Array.from(entriesMap.values());
      return result;
    },
    currentOffer() {
      return this.offerData;
    },
    cssVars() {
      return {
        "--header-text-color": this.component.dialog.content.heading.color,
        "--header-text-size": this.component.dialog.content.heading.size + "px",
        "--header-text-style": this.component.dialog.content.heading.style,
        "--header-text-weight": this.component.dialog.content.heading.weight,
        "--header-line-height": this.component.dialog.content.heading
          .lineHeight,
        "--header-font": this.component.dialog.content.heading.font,
        "--row-text-color": this.component.dialog.content.data.color,
        "--row-text-size": this.component.dialog.content.data.size + "px",
        "--row-text-style": this.component.dialog.content.data.style,
        "--row-text-weight": this.component.dialog.content.data.weight,
        "--row-line-height": this.component.dialog.content.data.lineHeight,
        "--row-font": this.component.dialog.content.data.font,
        "--text-align": this.component.dialog.content.align,
        "--row-border-bottom": this.rowBorders,
        "--row-hover-color": this.component.dialog.rowHoverColor.hexa,
        "--current-page-color": this.component.dialog.title.color
      };
    },
    classes() {
      if (this.component.dialog.fullscreen === true) return "rounded-0";
      return this.component.card.rounded;
    },
    grid() {
      return this.$store.getters.grid;
    },
    rowBorders() {
      return (
        this.component.dialog.rowBorderSize +
        "px" +
        " solid " +
        this.component.dialog.rowBorderColor.hexa
      );
    },
    iconAlign() {
      return this.component.dialog.content.align;
    },
    iconSize() {
      return this.component.dialog.iconSize;
    },
    gradient() {
      if (this.component.dialog.color.type === "gradient") {
        var color = this.component.dialog.color;
        var gradient =
          "background: linear-gradient(" +
          color.direction +
          ", rgba(" +
          color.gradientFrom.rgba.r +
          ", " +
          color.gradientFrom.rgba.g +
          ", " +
          color.gradientFrom.rgba.b +
          ", " +
          color.gradientFrom.rgba.a +
          ") " +
          ", rgba(" +
          color.gradientTo.rgba.r +
          ", " +
          color.gradientTo.rgba.g +
          ", " +
          color.gradientTo.rgba.b +
          ", " +
          color.gradientTo.rgba.a +
          ")" +
          color.gradientHeight +
          "%)";
        return gradient;
        // return 'background: linear-gradient(to top, rgba(0, 0, 255, 100), rgba(255, 0, 0, 100) 50%)'
      } else {
        return (
          "background: " + this.component.dialog.color.solidColor.hexa + ";"
        );
      }
    },
    styles() {
      // Helper function to ensure minimum padding
      const ensureMinPaddingX = value => Math.max(28, value);
      const ensureMinPaddingY = value => Math.max(20, value);

      var styles =
        "padding-bottom: " +
        ensureMinPaddingY(this.component.dialog.padding.bottom) +
        "px ;" +
        "padding-top: " +
        ensureMinPaddingY(this.component.dialog.padding.top) +
        "px ;" +
        "padding-left: " +
        ensureMinPaddingX(this.component.dialog.padding.left) +
        "px ;" +
        "padding-right: " +
        ensureMinPaddingX(this.component.dialog.padding.right) +
        "px ;" +
        "border: " +
        this.component.dialog.borderSize +
        "px solid " +
        ";";
      this.component.dialog.borderColor.hexa + "; ";
      return styles;
    },
    summaryTableStyles() {
      var styles =
        "margin-bottom: " +
        this.component.dialog.summary.margin.bottom +
        "px ;" +
        "margin-top: " +
        this.component.dialog.summary.margin.top +
        "px ;" +
        "margin-left: " +
        this.component.dialog.summary.margin.left +
        "px ;" +
        "margin-right: " +
        this.component.dialog.summary.margin.right +
        "px ;";
      return styles;
    },
    detailTableStyles() {
      var styles =
        "margin-bottom: " +
        this.component.dialog.detail.margin.bottom +
        "px ;" +
        "margin-top: " +
        this.component.dialog.detail.margin.top +
        "px ;" +
        "margin-left: " +
        this.component.dialog.detail.margin.left +
        "px ;" +
        "margin-right: " +
        this.component.dialog.detail.margin.right +
        "px ;";
      return styles;
    },
    webTheme() {
      return this.$store.getters.currentProgram.webTheme;
    },
    checkCompanies() {
      return this.currentUser.companies && this.currentUser.companies[0];
    },
    isClaimFormOpen() {
      // use deadline to check if the claim form is open
      const deadline = this.opportunity?.deadline;
      const currentDate = new Date();

      // If no deadline is set, form is always open
      if (!deadline) {
        return true;
      }

      // Convert Firestore Timestamp to JavaScript Date if needed
      let deadlineDate;
      try {
        deadlineDate = deadline.toDate ? deadline.toDate() : new Date(deadline);
      } catch (error) {
        console.warn("⚠️ Error converting deadline to date", {
          deadline,
          error
        });
        return true; // Default to open if deadline conversion fails
      }

      // Validate dates
      if (isNaN(deadlineDate.getTime()) || isNaN(currentDate.getTime())) {
        console.warn("⚠️ Invalid deadline or current date", {
          deadline,
          deadlineDate,
          currentDate
        });
        return true; // Default to open if dates are invalid
      }

      // Create UTC date objects for comparison (time set to 00:00:00 UTC)
      const currentUTC = new Date(
        Date.UTC(
          currentDate.getUTCFullYear(),
          currentDate.getUTCMonth(),
          currentDate.getUTCDate(),
          0,
          0,
          0,
          0 // Explicitly set time to midnight UTC
        )
      );

      const deadlineUTC = new Date(
        Date.UTC(
          deadlineDate.getUTCFullYear(),
          deadlineDate.getUTCMonth(),
          deadlineDate.getUTCDate(),
          0,
          0,
          0,
          0 // Explicitly set time to midnight UTC
        )
      );

      // Validate the created UTC dates
      if (isNaN(currentUTC.getTime()) || isNaN(deadlineUTC.getTime())) {
        console.warn("⚠️ Invalid UTC dates created", {
          currentUTC,
          deadlineUTC
        });
        return false; // Default to closed if UTC conversion fails
      }

      return currentUTC <= deadlineUTC;
    }
  },
  methods: {
    formatDate(value) {
      return DateUtils.formatDateTime(value);
    },
    formatDeadline(value) {
      const jsDate = DateUtils.toJsDate(value);
      if (!jsDate) return "";

      return (
        "Offer Ends " +
        jsDate.toLocaleDateString(["en-US"], {
          month: "short",
          day: "2-digit",
          year: "numeric"
        })
      );
    },
    getProductTitle(code) {
      const obj = this.products.find(el => el.code === code);
      if (obj) {
        return obj.title;
      }
      return "";
    },
    // Add a new method to generate a unique key for data table rows
    getItemKey(item) {
      // If the item is null or undefined, return a random key
      if (!item) {
        console.warn("Null or undefined item in getItemKey");
        return `random_${Math.random()
          .toString(36)
          .substr(2, 9)}`;
      }

      // First try to get the primary 'id' property from Firestore
      let itemId = item.id;

      // If 'id' is not available, try '_id' as fallback
      if (!itemId && item._id) {
        itemId = item._id;
      }

      // Try more advanced access methods if simple property access fails
      if (!itemId) {
        // Try to access 'id' property directly
        if (Object.prototype.hasOwnProperty.call(item, "id")) {
          const descriptor = Object.getOwnPropertyDescriptor(item, "id");
          if (descriptor && descriptor.value) {
            itemId = descriptor.value;
          }
        }
        // If still no id, try _id
        else if (Object.prototype.hasOwnProperty.call(item, "_id")) {
          const descriptor = Object.getOwnPropertyDescriptor(item, "_id");
          if (descriptor && descriptor.value) {
            itemId = descriptor.value;
          }
        }
      }

      // If we still don't have an ID, generate a random one
      if (!itemId) {
        console.warn("Item missing id in getItemKey:", item);
        itemId = `random_${Math.random()
          .toString(36)
          .substr(2, 9)}`;
      }

      return itemId;
    },
    openClaimForm() {
      // Fetch the current offer from the store to ensure we have the latest data
      const currentOffer = this.$store.getters.currentOffer;

      // Re-initialize formPagesArray with fresh data
      if (currentOffer && currentOffer.form && currentOffer.form.pages) {
        if (Array.isArray(currentOffer.form.pages)) {
          this.formPagesArray = JSON.parse(
            JSON.stringify(currentOffer.form.pages)
          );
        } else {
          this.formPagesArray = [];
        }
      } else {
        // Fallback to offerData if current offer doesn't have form data
        if (
          this.offerData &&
          this.offerData.form &&
          this.offerData.form.pages
        ) {
          if (Array.isArray(this.offerData.form.pages)) {
            this.formPagesArray = JSON.parse(
              JSON.stringify(this.offerData.form.pages)
            );
          } else {
            this.formPagesArray = [];
          }
        } else {
          this.formPagesArray = [];
        }
      }
      this.showClaimForm = true;
    },
    closeClaimForm() {
      this.showClaimForm = false;
    },
    async onSubmit() {
      this.openClaimForm();
    },
    isSerialValid(newSerial) {
      newSerial = newSerial.toLowerCase();
      return this.availableSerials.some(
        serial => serial.toLowerCase() === newSerial
      );
    },
    isSerialUsed(newSerial) {
      newSerial = newSerial.toLowerCase();
      return this.usedSerials.some(
        serial => serial.toLowerCase() === newSerial
      );
    },
    isSerialOnClaim(newSerial) {
      newSerial = newSerial.toLowerCase();
      return this.tempClaim.items.some(
        el => el.serial.toLowerCase() === newSerial
      );
    },
    openDelDialog(entry) {
      this.selectedEntry = entry;
      this.delDialog = true;
    },
    async confirmDelEntry() {
      try {
        this.loading = true;
        await this.$store.dispatch("delEntry", {
          offerId: this.offer.id,
          entry: this.selectedEntry
        });
        setTimeout(() => {
          this.loading = false;
          this.fileToUpload = [];
          this.delDialog = false;
          this.closeModal();
        }, 1000);
      } catch (error) {
        this.loading = false;
        console.error("Error deleting entry:", error);
      }
    },

    paginationStyle(val) {
      if (val === this.page) return "incentable-current-page";
      return "incentable-pagination";
    },
    handlePage(pageNum) {
      this.page = pageNum;
    },
    close() {
      this.$emit("onClose");
    },
    getFormPages() {
      if (this.offerData && this.offerData.form && this.offerData.form.pages) {
        // Create a plain array copy to avoid reactivity issues
        return Array.isArray(this.offerData.form.pages)
          ? [...this.offerData.form.pages]
          : [];
      }
      return [];
    },
    // Add method to get the effective offer ID, considering advanced offer groups
    getEffectiveOfferId() {
      // For advanced offer groups, use the parentOfferId which points to the actual offer
      if (this.offerData.isAdvancedGroup && this.offerData.parentOfferId) {
        return this.offerData.parentOfferId;
      }

      // For regular offers, use the offerId or id
      return this.offerData.offerId || this.offerData.id;
    },

    // Add method to load entries
    loadEntries() {
      const offerId = this.getEffectiveOfferId();
      if (!offerId) return;

      console.log("Loading entries for offer:", offerId);
      this.loading = true;
      this.$store
        .dispatch("fetchOfferEntries", offerId)
        .then(() => {
          this.entriesLoaded = true;
          this.loading = false;
          console.log("Entries loaded successfully");
        })
        .catch(error => {
          console.error("Error loading entries:", error);
          this.loading = false;
        });
    },
    // Add a method to determine row class based on entry type
    rowClass(item) {
      return item.isHistoryItem ? "history-item-row" : "";
    }
  }
};
</script>

<style scoped>
.tab-items {
  background-color: transparent !important;
}

/* Ensure v-tabs-items and v-tab-item have transparent backgrounds */
.v-tabs-items {
  background-color: transparent !important;
}

.v-window-item {
  background-color: transparent !important;
}

.v-tab-item {
  background-color: transparent !important;
}

/* Target Vuetify's internal classes for tab items */
::v-deep .v-tabs-items {
  background-color: transparent !important;
}

::v-deep .v-window-item {
  background-color: transparent !important;
}

::v-deep .v-tab-item {
  background-color: transparent !important;
}

.text-color {
  color: #a8a8a8;
}
.claim-heading {
  font-size: 14px;
  font-weight: 500;
}
.dz {
  border: 1px white;
  background-color: transparent;
  border-style: dashed;
}

/* History item styling */
.history-item-row {
  background-color: rgba(0, 0, 0, 0.03) !important;
  font-style: italic;
}

.animation-text {
  position: absolute !important;
  margin-top: 25px;
  font-size: 50px;
  z-index: 1000;
  font-weight: 700;
  font-family: Roboto;
  color: rgb(168, 0, 0);
}

.animated-icon {
  position: absolute !important;
  margin-top: -50px;
}
.animated-confetti {
  position: absolute !important;
  z-index: 1000;
  width: 70% !important;
  height: 70% !important;
  margin-left: -250px;
}
.svg-opacity {
  opacity: 0.5 !important;
}
.table.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-family: var(--header-font) !important;
  font-size: var(--header-text-size) !important;
  font-style: var(--header-text-style) !important;
  font-weight: var(--header-text-weight) !important;
  color: var(--header-text-color) !important;
  line-height: var(--header-line-height) !important;
  background-color: transparent !important;
  text-align: var(--text-align) !important;
  border-bottom: var(--row-border-bottom) !important;
}
.incentable-pagination {
  font-family: var(--header-font) !important;
  font-size: var(--header-text-size) !important;
  font-style: var(--header-text-style) !important;
  font-weight: var(--header-text-weight) !important;
  color: var(--header-text-color) !important;
}
.incentable-current-page {
  font-family: var(--header-font) !important;
  font-size: var(--header-text-size) !important;
  font-style: var(--header-text-style) !important;
  font-weight: var(--header-text-weight) !important;
  color: var(--current-page-color) !important;
}
.btn-pagination {
  padding-top: 5px;
}
.table.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-family: var(--row-font) !important;
  font-size: var(--row-text-size) !important;
  font-style: var(--row-text-style) !important;
  font-weight: var(--row-text-weight) !important;
  color: var(--row-text-color) !important;
  line-height: var(--row-line-height) !important;
  text-align: var(--text-align) !important;
  background-color: transparent !important;
  border-bottom: var(--row-border-bottom) !important;
}
.table.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-family: var(--header-font) !important;
  font-size: var(--header-text-size) !important;
  font-style: var(--header-text-style) !important;
  font-weight: var(--header-text-weight) !important;
  color: var(--header-text-color) !important;
  line-height: var(--header-line-height) !important;
  background-color: transparent !important;
  text-align: var(--text-align) !important;
  border: none !important;
}
.table.theme--light.v-data-table {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.87);
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: var(--row-hover-color) !important;
}
.v-tab--active {
  color: inherit !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  text-transform: capitalize;
}
.v-tab {
  font-size: 13px !important;
  font-weight: 500 !important;
  text-transform: capitalize;
}

/* Override vuetify default tab styling using more direct selectors */
.custom-tabs >>> .v-tab {
  color: v-bind("component.dialog.title.color") !important;
}

.custom-tabs >>> .v-tabs-slider {
  background-color: v-bind("component.dialog.title.color") !important;
}

.custom-tab {
  color: v-bind("component.dialog.title.color") !important;
}

/* Button styling with v-bind */
.claim-button {
  background-color: #333333 !important;
  color: white !important;
}

.close-button {
  color: v-bind("component.dialog.title.color") !important;
}

.custom-close-btn,
.custom-btn {
  color: v-bind("component.dialog.title.color") !important;
}
</style>
